import {Comment} from "../models/comment.model";
import {getApiUrl} from "../utils/util-functions";

export const getCommentsAsync = async (isPreviewMode: boolean = false) => {
    if (isPreviewMode) {
        return new Promise<any>((resolve) => {
            return [] as Comment[];
        })
    }

    return fetch(getApiUrl() + '/comments')
        .then((response) => {
            return response.json();
        })
        .then((response: any) => {
            return response['response'] as Comment[];
        });
};

export const createCommentAsync = async (commentText: string) => {
    return fetch(getApiUrl() + '/comment', {method: 'POST', body: JSON.stringify({text: commentText})})
        .then((response) => {
            return response.json();
        })
        .then((response: any) => {
            return response;
        });
}
